import axios from 'axios'
const _Authorization = 'Authorization', _Bearer = 'Bearer ';
let currentToken = '', _this = null;
axios.defaults.timeout = 50000;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = window.vueConfig.development.apiHost;
  window.hostConfig.webApiHost = window.vueConfig.development.apiHost;
  window.hostConfig.videoHost = window.vueConfig.development.videoHost;
  window.hostConfig.imageHost = window.vueConfig.development.imageHost;
}
else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = window.vueConfig.production.apiHost;
  window.hostConfig.webApiHost = window.vueConfig.production.apiHost;
  window.hostConfig.videoHost = window.vueConfig.production.videoHost;
  window.hostConfig.imageHost = window.vueConfig.production.imageHost;
}

function init(vue) {
  _this = vue;
}
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  if (res.status == 401 || res.status == 202) {
    _this.$message.error('登录已过期');
    localStorage.removeItem("userInfoWeb");
    _this.$router.push({ path: '/Login' })
  }
  return Promise.resolve(res);
}, (error) => {
  if (error.response) {
    if (error.response.status == 401 || error.response.status == 202) {
      localStorage.removeItem("userInfoWeb");
      _this.$router.push({ path: '/Login' })
    }
  }
  return Promise.reject(error.response);
});
function getToken() {
  // if (currentToken) {
  //   return _Bearer + currentToken;
  // }
  if (localStorage.getItem('userInfoWeb')) {
    let userInfoWeb = JSON.parse(localStorage.getItem('userInfoWeb'));
    return _Bearer + userInfoWeb.token;
  }
  return "";
}
function post(url, params) {
  axios.defaults.headers[_Authorization] = getToken();
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题~~');
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function get(url, param) {
  axios.defaults.headers[_Authorization] = getToken();
  return new Promise((resolve, reject) => {
    axios.get(url, { params: param })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default { post, get, init }


// WEBPACK FOOTER //
// ./src/api/http.js